var _defs, _g, _use, _rect, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecommendationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "109px",
    viewBox: "0 0 67 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "84.3774568%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "74.4755145%",
    x2: "19.6413923%",
    y2: "17.0874188%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.16844998,14.1920934 L36.4166564,14.1920934 C36.7233638,14.1920934 36.9719992,14.4407288 36.9719992,14.7474361 C36.9719992,14.7692794 36.9707104,14.7911037 36.9681397,14.8127952 L33.6145042,43.1099464 L33.6145042,43.1099464 C33.5327496,43.4082342 33.3863106,43.570955 33.1751871,43.5981087 C27.9042683,44.2760293 23.2566377,44.4274227 19.2925532,44.4274227 C15.3397171,44.4274227 10.4951489,43.964637 5.45494405,43.6028085 C5.21462806,43.5855566 5.05068055,43.4001729 4.96310151,43.0466575 L1.6169667,14.8127952 C1.58086991,14.5082193 1.79851516,14.2320496 2.10309096,14.1959529 C2.12478244,14.1933821 2.1466067,14.1920934 2.16844998,14.1920934 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.6%",
    y: "-3.3%",
    width: "105.2%",
    height: "113.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "7.66860992e-05 0.00424744047 8.81766504 0.00424744047 8.81766504 4.5201958 7.66860992e-05 4.5201958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.262373,0 C24.1427507,0 29.0231283,0.277848617 33.903506,0.833545852 C34.8983371,0.946810414 35.69443,1.71161966 35.8474747,2.70111195 L36.2310167,5.183 L36.4649996,5.18319931 C37.13294,5.18319931 37.6744127,5.72467203 37.6744127,6.39261248 C37.6744127,6.73143693 37.5350808,7.03771866 37.3105877,7.25728701 L37.3320125,7.25647904 C37.5419329,7.25647904 37.7339129,7.37484558 37.8281937,7.56240275 L38.0218097,7.94757228 C38.1401035,8.18289972 38.045229,8.46956638 37.8099015,8.58786018 C37.7434439,8.62126695 37.6700934,8.63866552 37.5957117,8.63866552 L0.581637296,8.63866552 C0.318250834,8.63866552 0.10473392,8.42514861 0.10473392,8.16176214 C0.10473392,8.08738046 0.122132494,8.01402995 0.155539265,7.94757228 L0.349155293,7.56240275 C0.44343605,7.37484558 0.635416095,7.25647904 0.845336445,7.25647904 L1.21415824,7.25728701 C0.989665118,7.03771866 0.850333218,6.73143693 0.850333218,6.39261248 C0.850333218,5.72467203 1.39180594,5.18319931 2.05974639,5.18319931 L2.29201673,5.183 L2.67727011,2.70111908 C2.83031025,1.71162897 3.62640085,0.946821876 4.62122788,0.833547224 C9.50160958,0.277849075 14.3819913,0 19.262373,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.9%",
    y: "-11.6%",
    width: "110.2%",
    height: "123.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "643.12313%",
    gradientTransform: "translate(0.500000,0.500000),scale(1.000000,0.072690),rotate(90.000000),scale(1.000000,0.050872),translate(-0.500000,-0.500000)",
    id: "radialGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "75.4740169%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "40.922375%",
    y2: "21.5777229%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-20.2%",
    y: "-16.2%",
    width: "140.1%",
    height: "132.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.649945644,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "44.0687522%",
    fx: "50%",
    fy: "44.0687522%",
    r: "198.40551%",
    gradientTransform: "translate(0.500000,0.440688),scale(1.000000,0.447154),rotate(90.000000),translate(-0.500000,-0.440688)",
    id: "radialGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-16",
    x: 14.074834,
    y: 54.2099237,
    width: 23.5114504,
    height: 52.5801527,
    rx: 11.7557252
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.4%",
    y: "-2.9%",
    width: "112.8%",
    height: "105.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.752689085   0 0 0 0 0.752689085   0 0 0 0 0.752689085  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Lifestyle-Assessment-Intro",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1012.000000, -1582.000000)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1014.000000, 1582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54340426,8.33014175 L37.0417021,8.33014175 L31.5454351,53.4788665 C31.4025493,53.9055913 31.1484911,54.1630094 30.7832604,54.2511209 C26.9649635,55.1722807 11.6493723,55.1723821 7.84231064,54.2599527 C7.45010355,54.1659533 7.18144118,53.8960432 7.03632353,53.4502224 L1.54340426,8.33014175 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(11.293202, 21.598269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9624838,12.9552401 C13.8962051,13.0922391 13.8416015,13.2196812 13.7750254,13.3403399 C13.2643116,14.2658441 12.426023,14.7050208 11.4471954,14.9109473 C10.3453883,15.1427394 9.27408348,14.9895268 8.23456428,14.5778799 C7.47264876,14.2761618 6.79313167,13.8420885 6.22207064,13.2441838 C5.7208722,12.7194223 5.33667485,12.1221198 5.17239444,11.4023994 C5.11996619,11.1727469 5.11115511,10.9328401 5.08346987,10.6974978 C5.08141969,10.6800481 5.08814928,10.6615522 5.09160798,10.6380798 C5.58368234,10.5486596 6.06502064,10.4001383 6.57210355,10.4108681 C7.59858612,10.4325813 8.45772083,10.8280146 9.13276196,11.6082149 C9.73773703,12.3074109 10.4673661,12.7964169 11.3559702,13.0342158 C12.0176304,13.211297 12.6846273,13.2215355 13.3543161,13.0788625 C13.5493022,13.0373222 13.7450396,12.9993162 13.9624838,12.9552401",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6385421,7.76474373 C12.0945403,7.46178948 11.5089872,7.2360834 11.0459753,6.79977539 C10.751125,6.52194185 10.5039141,6.2073544 10.3199144,5.84445911 C10.0677111,5.34705307 9.9384715,4.82002519 9.9246367,4.25814529 C9.90133352,3.31138749 9.59965979,2.45844011 9.03218266,1.70451748 C8.60532279,1.13739155 8.06532745,0.710894088 7.43388785,0.399904373 C7.38271162,0.374704411 7.33299086,0.346461435 7.28259713,0.319644872 C7.2805626,0.311339979 7.27851242,0.303019237 7.2764779,0.294714344 C7.43731525,0.233758965 7.59506951,0.16208964 7.75952207,0.113718393 C8.38930275,-0.0715092497 9.01351194,-0.0182723496 9.62878486,0.18535602 C10.4301859,0.450589579 11.1010171,0.923889236 11.6744413,1.54071773 C12.4816017,2.40897528 13.0124103,3.4266258 13.2371006,4.59989798 C13.3828981,5.3612538 13.3627406,6.11720511 13.1202873,6.86001756 C13.0204076,7.16601483 12.8197247,7.54965651 12.6385421,7.76474373",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(5.289776, 7.760495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66860992e-05,1.9174318 C0.132055028,1.61081642 0.304598751,1.34604248 0.525313864,1.11391755 C0.923048665,0.695614036 1.40410526,0.411060507 1.94754365,0.24014454 C2.20132769,0.160312964 2.46429841,0.100498715 2.72745693,0.0626987725 C4.13300357,-0.139297147 5.42943686,0.190378578 6.6322505,0.925805384 C7.33909288,1.35796095 7.92495903,1.92190123 8.34615351,2.6488171 C8.61242643,3.1083598 8.77886656,3.60083679 8.81674011,4.1354722 C8.82218639,4.21248265 8.80519024,4.24438675 8.72484199,4.25980786 C8.33349248,4.33483718 7.94665024,4.44270569 7.55249934,4.49217052 C6.64520888,4.60607752 5.81870489,4.37141674 5.090453,3.81270665 C4.89053703,3.65933556 4.70719465,3.47745207 4.54087972,3.28664557 C3.80425496,2.44160685 2.88992191,1.93824158 1.7873949,1.78785011 C1.27295638,1.71768644 0.762759068,1.75282375 0.257194221,1.86828395 C0.183528616,1.88511562 0.109409153,1.90001371 0.0354461931,1.91552992 C0.0283879419,1.91701972 0.0208914844,1.91641746 7.66860992e-05,1.9174318",
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.770208575,11.215468 C0.671612161,11.0842697 0.564548977,10.9586661 0.475953057,10.8208905 C0.146234131,10.3081109 0.0074166413,9.73829062 0.000311439464,9.13120928 C-0.0084839866,8.37967985 0.170319826,7.67130735 0.492949201,6.99987893 C1.0756853,5.78719021 1.95284908,4.85645578 3.12941729,4.2214326 C3.64720496,3.94196661 4.19862496,3.7634431 4.78399031,3.69946056 C4.80472685,3.69721 4.82551035,3.69505453 4.84632515,3.69374816 C4.85380596,3.69335868 4.86144327,3.69572019 4.87579452,3.69778056 C4.89019273,3.81927925 4.90257205,3.94176057 4.9195056,4.06360793 C5.01767945,4.76979327 5.2263439,5.44179225 5.53820592,6.08039731 C5.5758447,6.15745531 5.57221385,6.20676165 5.52063071,6.27532456 C5.07247089,6.87127988 4.49871802,7.28354492 3.79433272,7.51378381 C2.90358455,7.80494639 2.17736719,8.33287766 1.62137732,9.09515273 C1.21013638,9.65895036 0.953629204,10.2911524 0.838568754,10.9823763 C0.826142476,11.0569935 0.808786378,11.1307708 0.793715212,11.2049442 C0.785874449,11.2084469 0.778033687,11.2119495 0.770208575,11.215468",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0006921,6.97625437 C9.77046165,6.94725064 9.55171846,6.91540993 9.33203626,6.89280921 C8.64937348,6.82258215 7.97486446,6.87591414 7.30969863,7.04445275 C7.24557966,7.06069801 7.21103961,7.04556219 7.17131934,6.99747622 C6.52455817,6.21440722 6.07738431,5.33044329 5.86285104,4.33095575 C5.6962544,3.55467014 5.69318696,2.78055584 5.92529543,2.01480984 C6.04669422,1.61430479 6.23606194,1.24999893 6.5126327,0.922890747 C6.61581463,0.977157834 6.72093719,1.02790644 6.82170898,1.08631012 C7.09942221,1.2472412 7.39247266,1.38775872 7.64869814,1.57867616 C8.42026984,2.15352057 8.87373509,2.93256392 9.0069498,3.8943783 C9.04377478,4.16022997 9.04252276,4.43126428 9.06807958,4.69900198 C9.11230711,5.16241184 9.23904263,5.60391834 9.42435694,6.02962335 C9.5720794,6.36898284 9.76755071,6.67769029 10.0006921,6.97625437",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07478638,7.02079966 C6.16480647,7.14416853 6.25538997,7.26829815 6.34802364,7.3952489 C6.02096525,7.56117242 5.72008969,7.7580491 5.4451935,7.99606987 C4.96286924,8.41367603 4.63338507,8.93436429 4.38762959,9.52336189 C4.26403977,9.81956445 4.19211134,10.113675 4.2030352,10.4330171 C4.20935789,10.6175157 4.18528784,10.804455 4.20589919,10.9867031 C4.23392874,11.2347087 4.29161547,11.4792751 4.33642206,11.7253314 C4.33734542,11.7303714 4.33654726,11.7357442 4.33654726,11.7574891 C4.19142273,11.8039743 4.04429497,11.8659915 3.89106363,11.8969288 C3.61068986,11.9535416 3.32818766,12.0112004 3.04391698,12.0333415 C2.57312694,12.0700003 2.11214958,12.002737 1.67056285,11.822264 C1.60919832,11.7971909 1.58248339,11.774717 1.60037159,11.6972627 C1.6845072,11.3329727 1.72856258,10.9559876 1.84484375,10.6031089 C2.21119985,9.49142609 2.95710519,8.74357364 4.05457717,8.37134326 C4.83192381,8.10767876 5.49638539,7.68075337 6.03429925,7.05348036 C6.04112274,7.04552415 6.04811839,7.03764718 6.05577135,7.03056266 C6.05940221,7.02721851 6.06477023,7.02580795 6.07478638,7.02079966",
    id: "Fill-12",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7071331,22.0457808 C26.4824551,20.2485419 23.101263,19.1015059 19.3149183,19.1015059 C15.5071943,19.1015059 12.1092112,20.2615317 9.88512994,22.0762868",
    id: "Oval",
    stroke: "#D9D9D9",
    strokeWidth: 1.18723404,
    strokeDasharray: "1.110685694217682,1.110685694217682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7071331,39.5674267 C26.4824551,37.7701878 23.101263,36.6231518 19.3149183,36.6231518 C15.5071943,36.6231518 12.1092112,37.7831776 9.88512994,39.5979327",
    id: "Oval",
    stroke: "#D9D9D9",
    strokeWidth: 1.18723404,
    strokeDasharray: "1.110685694217682,1.110685694217682",
    transform: "translate(19.296131, 38.110542) rotate(-180.000000) translate(-19.296131, -38.110542) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-9)",
    opacity: 0.200000003,
    transform: "translate(19.138213, 5.244904) rotate(-90.000000) translate(-19.138213, -5.244904) ",
    cx: 19.1382128,
    cy: 5.24490407,
    rx: 1,
    ry: 16.9774468
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-10)",
    opacity: 0.200000003,
    transform: "translate(19.138213, 6.170475) rotate(-90.000000) translate(-19.138213, -6.170475) ",
    cx: 19.1382128,
    cy: 6.17047537,
    rx: 1.23409507,
    ry: 16.9774468
  })), /*#__PURE__*/React.createElement("g", {
    id: "tea",
    transform: "translate(14.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38847311,1.18920726 C9.20585559,0.396402419 14.0091484,0 19.7983514,0 C25.5875568,0 30.3908511,0.39640273 34.2082343,1.18920819 L34.2082335,1.18921196 C37.2971315,1.83072345 39.4792784,4.59780607 39.3830369,7.751148 C38.8806799,24.2108157 32.3524514,32.4406495 19.7983514,32.4406495 C7.2442514,32.4406495 0.716022921,24.2108156 0.213665995,7.75114783 L0.21366548,7.75114785 C0.117423904,4.59780351 2.29957269,1.83071887 5.38847311,1.18920726 Z",
    id: "Path-23",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 19.9799819,
    cy: 3.28051512,
    rx: 17.6181597,
    ry: 2.18701008
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-12)",
    opacity: 0.200000003,
    transform: "translate(19.798351, 3.098264) rotate(-90.000000) translate(-19.798351, -3.098264) ",
    cx: 19.7983514,
    cy: 3.09826428,
    rx: 2.18701008,
    ry: 17.6181597
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8750758,9.49740782 C51.029187,13.2556087 48.8750758,19.4710947 39.6842016,23.0847493 C38.3917349,23.6629341 38.3917349,26.2647654 34.5143348,25.8311269 C31.9294014,25.5420345 33.4641269,19.4225742 39.1185112,7.47274605 C44.1868135,6.31705334 47.4390017,6.99194059 48.8750758,9.49740782 Z M46.8209306,11.0257345 C45.6284298,9.37404514 41.8383127,9.641954 40.9766683,10.3646849 C40.1150238,11.0874159 37.5300904,19.9047332 40.545846,19.9047332 C44.1360313,19.3265485 48.0134313,12.6774239 46.8209306,11.0257345 Z",
    id: "Combined-Shape",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4370707,8.74804031 L30.1692178,10.6075255 C30.3063082,10.7008285 30.40255,10.8430038 30.4382414,11.0049462 L32.4177927,19.9867622 C32.4950507,20.3373046 32.2735099,20.6841053 31.9229675,20.7613632 C31.8770269,20.7714883 31.8301228,20.7765957 31.7830796,20.7765957 L25.7501704,20.7765957 C25.4451178,20.7765957 25.1811138,20.5644412 25.1154573,20.266538 L23.1319998,11.2669985 C23.0659288,10.9672146 23.2186149,10.6620798 23.4981636,10.5352402 L27.4370707,8.74804031 Z M27.4370707,10.9350504 C27.0303684,10.9350504 26.700671,11.3430328 26.700671,11.8463046 C26.700671,12.3495764 27.0303684,12.7575588 27.4370707,12.7575588 C27.843773,12.7575588 28.1734704,12.3495764 28.1734704,11.8463046 C28.1734704,11.3430328 27.843773,10.9350504 27.4370707,10.9350504 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-13)",
    filter: "url(#filter-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5186804,8.38353863 L29.667627,10.3791395 C29.8556909,10.4983223 29.9696601,10.7054769 29.9696601,10.928126 L29.9696601,17.93964 C29.9696601,18.2985951 29.6786695,18.5895857 29.3197145,18.5895857 L23.7176463,18.5895857 C23.3586912,18.5895857 23.0677007,18.2985951 23.0677007,17.93964 L23.0677007,10.928126 C23.0677007,10.7054769 23.1816698,10.4983223 23.3697338,10.3791395 L26.5186804,8.38353863 Z M26.5186804,9.84154535 C26.1374957,9.84154535 25.8284844,10.1679313 25.8284844,10.5705487 C25.8284844,10.9731662 26.1374957,11.2995521 26.5186804,11.2995521 C26.8998651,11.2995521 27.2088763,10.9731662 27.2088763,10.5705487 C27.2088763,10.1679313 26.8998651,9.84154535 26.5186804,9.84154535 Z",
    id: "Combined-Shape",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(22.704440, 12.028555)",
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55820439,3.67880095 C5.14696597,2.90932541 4.24795817,2.01122995 3.05115009,1.78497281 C1.85434201,1.55871566 1.48950969,2.10866089 0.452276016,1.91257137 C1.14326875,2.57638851 4.78330901,4.58810612 5.55820439,3.67880095 Z",
    id: "Path-26",
    transform: "translate(3.005240, 2.820073) rotate(39.000000) translate(-3.005240, -2.820073) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19727378,3.6450168 C4.89437144,3.3907133 4.46165381,2.54303497 4.89437144,1.69535665 C5.18284986,1.13023777 5.73095886,0.565118883 6.53869844,0 C6.42330707,0.593374827 6.36561139,1.04546993 6.36561139,1.35628532 C6.36561139,1.8225084 6.14925257,3.43309722 5.19727378,3.6450168 Z",
    id: "Path-27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.8840058,4.73852184 L24.8840058,4.55316936 C24.8840058,4.05161055 25.2905995,3.6450168 25.7921583,3.6450168 C26.2937171,3.6450168 26.7003109,4.05161055 26.7003109,4.55316936 L26.7003109,9.84154535 L26.7003109,9.84154535",
    id: "Path-25",
    stroke: "#FFFFFF",
    strokeWidth: 1.48404255,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-15)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-16"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#EBEBEB",
    fill: "url(#linearGradient-18)",
    x: 12.3649103,
    y: 52.5,
    width: 26.9312977,
    height: 56,
    rx: 13.4656489
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5CE0B0",
    cx: 25.8351355,
    cy: 94.9744442,
    r: 5.79541919
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#FF520B",
    opacity: 0.223996185,
    cx: 25.8351355,
    cy: 80.3719905,
    r: 5.79541919
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#DF0035",
    opacity: 0.223996185,
    cx: 25.8351355,
    cy: 65.7695368,
    r: 5.79541919
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsIcon);
export default __webpack_public_path__ + "static/media/recommendations-icon.590c5a56a055003d449c08755ff99da4.svg";
export { ForwardRef as ReactComponent };